
import Env from '../base/env.js';
import Channels from '../base/channels.js';
// import LoconativeScroll from 'loconative-scroll';
import Smoothie from '../fx/Smoothie'


class UI
{
    constructor()
    {
      if(typeof history.scrollRestoration != 'undefined') {
          history.scrollRestoration = 'manual';
      }
      this.detectAppHeight()
      this.resetEnv();

      // const scroll = new LoconativeScroll({
      //   el:document.getElementById('jsSmoothWrapper'),
      //   duration:1.5,
      //   smooth:true,
      //   easing:(t) => (t === 1 ? 1 : 1 - Math.pow(1 - t, 5))
      // });
      // Smooth
      this.smoothie = new Smoothie()
      this.smoothie.setup()
    }

    appHeight()
    {
      const doc = document.documentElement
      doc.style.setProperty('--app-height', `${window.innerHeight}px`)
    }

    detectAppHeight()
    {
      this.appHeight()
      Channels.on('window::smartresize',this.appHeight)
    }

    resetEnv()
    {
      Channels.on('statechange::before',function()
      {
        Env.$html.classList.remove('mainnav--isOpened')
        Env.$html.classList.remove('subnav--isOpened')
      })
      Channels.on('statechange::ready',(current,old,container)=>
      {
        Env.isVisiting = true
        // Env.$html.classList.remove('skin--isWhite')
        // Env.$html.classList.remove('skin--isDark')
        // Env.$mainNav.classList.remove('is--active');
        // Env.$html.classList.remove('mainnav--isOpened')
      })
      Channels.on('statechange::finalize',()=>{

      })
    }
}

export default UI;
